<div class="row mt-5">
  <div class="col-12" style="padding-right: 0 !important; margin-right: 0 !important">
    <div class="card">
      <div class="card-body">
        <!-- Header with Add Note Button -->
        <div class="d-flex justify-content-between align-items-center mb-3" *ngIf="!loading && !error">
          <h5 class="card-title mb-0">Notes</h5>
          <button 
            type="button" 
            class="btn btn-info btn-sm"
            (click)="openAddNoteModal()"
            title="Add Note">
            <i class="fa fa-solid fa-plus"></i>
            Add Note
          </button>
        </div>

        <!-- Loading State -->
        <div *ngIf="loading" class="text-center py-4">
          <div class="spinner-border text-primary" role="status">
            <span class="sr-only">Loading notes...</span>
          </div>
          <p class="mt-2 text-muted">Loading notes...</p>
        </div>

        <!-- Error State -->
        <div *ngIf="error && !loading" class="alert alert-danger d-flex align-items-center justify-content-between" role="alert">
          <div>
            <i class="fas fa-exclamation-triangle me-2"></i>
            {{ errorMessage }}
          </div>
          <button type="button" class="btn btn-outline-danger btn-sm" (click)="retryLoad()">
            <i class="fas fa-redo me-1"></i>
            Retry
          </button>
        </div>

        <!-- Empty State -->
        <div *ngIf="!loading && !error && notes.length === 0" class="text-center py-5">
          <i class="fas fa-sticky-note fa-3x text-muted mb-3"></i>
          <h5 class="text-muted">No notes yet</h5>
          <p class="text-muted">Notes will appear here when they are added to this candidate.</p>
          <button 
            type="button" 
            class="btn btn-info mt-3"
            (click)="openAddNoteModal()">
            <i class="fas fa-plus me-1"></i>
            Add First Note
          </button>
        </div>

        <!-- Notes Table -->
        <div *ngIf="!loading && !error && notes.length > 0">
          <div class="table-responsive">
            <table class="table table-striped table-hover">
              <thead class="table-light">
                <tr>
                  <th scope="col">Date Created</th>
                  <th scope="col">Text</th>
                  <th scope="col">Type</th>
                  <th scope="col">Created By</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let note of notes; trackBy: trackByNoteId">
                  <td>{{ note.dateAdded || 'yyyy-MM-dd' }}</td>
                  <td>
                    <div class="text-truncate" style="max-width: 300px;" [title]="note.comments">
                      {{ note.comments || '-' }}
                    </div>
                  </td>
                  <td>
                    <span class="">{{ note.action || '-' }}</span>
                  </td>
                  <td>{{ note.commentingPersonName || '-' }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Add Note Modal -->
<app-candidate-note-modal
  [isVisible]="isNoteModalVisible"
  [candidateName]="candidateName"
  [candidateId]="candidateID"
  [noteTypes]="noteTypes"
  [successMessage]="modalSuccessMessage"
  [loading]="modalLoading"
  (saveNote)="saveNote($event)"
  (closeModal)="onNoteModalClose()">
</app-candidate-note-modal>